import { isFranchisLogin } from "../../utils/userRoles"
import AdminDashboard from "./admin-dashboard"
import FirebaseIntegration from "./firbase-integration"
import FODashboard from "./fo-dashboard"

function Dashboard() {
    return (
        <>

            {/* {
        isFranchisLogin()?<FODashboard/>:<AdminDashboard/>
        
    } */}
            {/* <div className="d-flex flex-row justify-content-center">
                <video controls autoPlay name="media">
                    <source src="https://s3.radio.co/s162c52c51/listen" type="audio/mpeg">
                    </source>
                </video>
            </div> */}
           

        </>
    )
}
export default Dashboard